import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AxiosError } from "axios";
import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";
import { EmitError } from "../../../utils/EmitError";
import { ISupport } from "../interfaces";
import SupportService from "../../../services/http/services/SupportService";

export default function useViewSupport() {
    const { id } = useParams();
    const [data, setData] = useState<ISupport>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const type = searchParams.get('type');

    const isGeneral = useMemo(() => {
        return type?.toLowerCase() === "general";
    }, [type]);

    useEffect(() => {
        const controller = new AbortController();

        async function loadMessageSupport() {
            try {
                setIsLoading(true);
                const messageData = await SupportService.getSupportById(Number(id), controller.signal);

                setData(messageData);
                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {
                    return;
                }

                setIsLoading(false);

                EmitError(err, true, 'editMessage_opasdasjpdasd');

                navigate(`/ajuda-e-suporte/externo/`);
            }
        }

        loadMessageSupport();

        return () => {
            controller.abort();
        }
    }, [id, navigate, isGeneral]);

    async function handleStatusChange(status: string, observation?: string) {
        const controller = new AbortController();
        try {
            await SupportService.updateStatusSupport(Number(id), status, observation);

            setIsLoading(true);
            const messageData = await SupportService.getSupportById(Number(id), controller.signal);

            setData(messageData);
            setIsLoading(false);

            EmitSuccessAlert('Atendimento atualizado com sucesso!');
        } catch (err) {
            EmitError(err, true, 'changeStatusContact_asiopdasodasd');
        }
    }

    return {
        isLoading,
        data,
        handleStatusChange
    }
}
